<template>
    <div class="page-container">
        <div class="tabbox">
            <div class="tabs">
                <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">获取记录</div>
                <div class="tab-item" :class="{actived:currentTab == 2}" @click="changeTab(2)">使用记录</div>
            </div>
        </div>
        <div class="num-detail">
            <span>总划转：¥0</span>
            <span>总提现：¥0</span>
        </div>
        <template v-if="list.length > 0">
            <!-- 获取记录 -->
            <div class="record-list" v-if="currentTab == 1">
                <div class="record-item" v-for="(item,index) in list" :key="index">
                    <div class="item-top">
                        <div class="item-count">御粮春生</div>
                        <div class="item-status">+{{item.amount}}</div>
                    </div>
                    <div class="item-bottom">
                        <span>来自：{{item.from}}</span>
                        <span>{{item.createTime | formatCreatetime}}</span>
                    </div>
                </div>
                <div class="record-item no-more">没有更多了</div>
            </div>
            <!-- 使用记录 -->
            <div class="record-list" v-else>
                <div class="record-item" v-for="(item,index) in list" :key="index">
                    <div class="item-top">
                        <div class="item-count">-{{item.amount}}</div>
                        <div class="item-status waiting">提现处理中</div>
                    </div>
                    <div class="item-bottom">
                        <span>{{item.describe}}</span>
                        <span>{{item.createTime | formatCreatetime}}</span>
                    </div>
                </div>
                <div class="record-item no-more">没有更多了</div>
            </div>
        </template>
        <!-- 无记录 -->
        <div class="record-none" v-else>
            <img src="" alt="">
            <div class="record-none-text">您还没有提货记录</div>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            currentTab:1,//1 获取记录，2 使用记录
            page:1,
            limit:50,
            list:[],
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        this.getData();
    },
    methods:{
        changeTab(tab){
            this.currentTab=tab;
            this.list=[];
            this.getData();
        },
        getData(){
            $http({
                method:'post',
                data:{
                    accountType:3,//1 账户，2 推荐奖励，3 津贴
                    opType:this.currentTab,
                    // type:this.filterType,
                    page:this.page,
                    limit:this.limit
                },
                url:config.api.accountList
            }).then(res=>{
                if(res.errno ==0){
                    this.list=res.data.list;
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    padding: 0 10px;
    background:#f5f5f5;
    min-height: calc(100vh - 46px);
    padding-top: 65px;
    box-sizing: border-box;
    .tabbox{
        position: fixed;
        background: #fff;
        top:46px;
        left:0;
        width:100vw;
        height:65px;
        box-sizing: border-box;
        padding: 12px 38px;
        .tabs{
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            .tab-item{
                width:50%;
                height:40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color:#2172F6;
                box-sizing: border-box;
                border:1px solid #3088F5;
                &.actived{
                    color:#fff;
                    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
                    border:none;
                }
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    border-right: none;
                }
                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-left: none;
                }
            }
        }
    }
    .num-detail{
        font-size: 14px;
        color:#666;
        line-height: 20px;
        padding:15px 0;
        &>span{
            margin-right: 20px;
        }
    }
    .record-list{
        background: #fff;
        padding:0 20px;
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        .record-item{
            padding:14px 0;
            border-bottom: 1px solid #f5f5f5;
            &:last-child{
                border:none;
            }
            .item-top{
                @include flex-between();
                line-height: 25px;
                margin-bottom: 5px;
                .item-count{
                    font-size: 18px;
                    color:#333;
                    font-weight: 400;
                    font-family: PingFangSC-Regular, PingFang SC;
                }
                .item-status{
                    font-size: 15px;
                    color:#666;
                    &.waiting{
                        color:#FFA11F;
                    }
                }
            }
            .item-bottom{
                @include flex-between();
                line-height: 18px;
                color:#999;
                font-size: 12px;
            }
            &.no-more{
                color:#999;
                font-size: 12px;
                text-align: center;
            }
        }
    }
    .record-none{
        margin-top: 85px;
        text-align: center;
        &>img{
            width:140px;
            height:108px;
            margin-bottom: 5px;
        }
        .record-none-text{
            font-size: 14px;
            color: #999;
            line-height: 20px;
        }
    }
}
</style>